import { Component } from '@angular/core';
import { environment } from 'environments/environment';
import { appInfo } from 'app.info';

@Component({
    selector: 'epx-env-indicator',
    template: `
        @if (!isProd) {
            <section class="_env-indicator">
                <div>
                    <span>{{ appInfo.env.toUpperCase() }}</span>
                </div>
            </section>
        }
    `,
    styleUrl: './env-indicator.component.scss'
})
export class EnvIndicatorComponent {
    appInfo = appInfo;

    get isProd() {
        return environment.production;
    }
}
